import React, {Component} from 'react';
import Select from "react-select";

class CreateOrderVpsUsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOs: false,
            // isAddon: false,
            isChosseProduct: false,
        }
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.props.changeInput(name, value);
    }

    changeQtt = (event) => {
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.props.changeQtt(value);
    }

    choosseOs = (event) => {
        let name = 'os';
        let value = event.target.value;
        this.props.changeInput(name, value);
    }

    chooseStateUs = (event) => {
        let name = 'stateUs';
        let value = event.target.value;
        this.props.changeInput(name, value);
    }

    changeAddonCpu = (num) => {
        this.props.changeAddonCpu(num);
    }

    changeAddonRam = (num) => {
        this.props.changeAddonRam(num);
    }

    changeAddonDisk = (num) => {
        this.props.changeAddonDisk(num);
    }

    render() {
        return (
            <>
                {/*Sản phẩm*/}
                <div className="row form-group mt-4">
                    <div className="col-md-3 text-right font-weight-bold">Sản phẩm</div>
                    <div className="col-md-8">
                        <Select
                            options={this.props.listProduct}
                            onChange={ this.props.choosseProduct() }
                            className="basic-single"
                            classNamePrefix="select"
                            placeholder={'Chọn sản phẩm'}
                        />
                    </div>
                </div>

                <div className="row form-group mt-4">
                    <div className="col-md-3 text-right font-weight-bold">Thời gian thuê</div>
                    <div className="col-md-8">
                        <Select
                            options={this.props.listBillingCycle}
                            onChange={ this.props.choosseBillingCycle() }
                            className="basic-single"
                            classNamePrefix="select"
                            placeholder={'Chọn thời gian thuê'}
                        />
                    </div>
                </div>

                {/*Số lượng*/}
                <div className="row form-group mt-4">
                    <div className="col-md-3 text-right font-weight-bold">Số lượng</div>
                    <div className="col-md-8">
                        <input type="number" className="form-control" onChange={ this.changeQtt } value={ this.props.qtt } />
                    </div>
                </div>

                {/*  State  */}
                <div className="row form-group mt-4">
                    <div className="col-md-3 text-right font-weight-bold">Chọn bang</div>
                    <div className="col-md-8">
                        <select name="state" value={ this.props.stateUs } className="form-control" onChange={ this.chooseStateUs }>
                            <option value="">Chọn Bang</option>
                            {
                                this.props.stateUsList.length ? (
                                    this.props.stateUsList.map( (stateUs, key) => {
                                        return (
                                            <option value={ stateUs.name } key={key}>{ stateUs.name }</option>
                                        )
                                    })
                                ) : (
                                    <></>
                                )
                            }
                        </select>
                    </div>
                </div>

                {/*  Hệ điều hành  */}
                <div className="row form-group mt-4">
                    <div className="col-md-3 text-right font-weight-bold">Hệ điều hành</div>
                    <div className="col-md-8">
                        <select name="os" defaultValue={12} className="form-control" onChange={ this.choosseOs }>
                            <option value="12" disabled={true}>Windows Server 2012 R2</option>
                        </select>
                    </div>
                </div>

                {/*  Trừ tiền tài khoản  */}
                {
                    this.props.status === 'Finish' ? (
                        <div className="row form-group mt-4">
                            <div className="col-md-3 text-right font-weight-bold">Trừ tiền tài khoản</div>
                            <div className="col-md-8">
                                <input type="checkbox" name="minusCredit" onChange={ this.changeInput } value={ this.props.minusCredit } />
                            </div>
                        </div>
                    ) : (
                        <></>
                    )
                }
            </>
        );
    }
}

export default CreateOrderVpsUsComponent;